<template>
  <pt-apply-form ref="form" class="pt-apply-form__withData"></pt-apply-form>
</template>

<script>
import PtApplyForm from './index'
export default {
  name: 'pt-apply-form__withData',
  components: {
    'pt-apply-form': PtApplyForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    submit () {
      this.form.validate().then(formValue => {
        this.$store.dispatch('').then(data => {
          // doing something ...
        }).catch(errorMessage => {
          console.error(errorMessage)
          this.$toast.error(errorMessage)
        })
      })
    }
  }
}
</script>
